import React, { useState, useEffect } from "react";
import commonStyles from "../../Shared/commonStyles.module.css";
import reviewsStyles from "./Reviews.module.css";
import useReviewStore from "../../../Stores/useReviewStore";
import { Link } from "react-router-dom";

function Reviews() {
  const { reviews, reviewHighLights, getReviews, getReviewHighlights } =
    useReviewStore();

  useEffect(() => {
    const fetchData = async () => {
      await getReviewHighlights(1, 3);
    };
  if (reviewHighLights.Items?.length === 0) {
 fetchData();
}
  }, []);

  return (
    <section className={`${commonStyles.section}`}>
        
      {reviewHighLights && reviewHighLights.Items && reviewHighLights.Items.length > 0 && (
        <div className={commonStyles.container}>
          <span className={commonStyles.eyebrow}>Reviews</span>
          <h2>Trusted by customers across Jersey</h2>
          <div className={reviewsStyles.reviews}>
            {reviewHighLights.Items.map((review) => (
              <article className={reviewsStyles.review} key={review.Id}>
                <p>"{review.ReviewText}"</p>
                <div>
                  {review.ReviewDate && (
                    <span>
                      {(() => {
                        let d = new Date(review.ReviewDate);
                        if (isNaN(d)) {
                          // Try DD.MM.YYYY
                          const parts = review.ReviewDate.match(
                            /^(\d{2})\.(\d{2})\.(\d{4})$/,
                          );
                          if (parts)
                            d = new Date(`${parts[3]}-${parts[2]}-${parts[1]}`);
                        }
                        return isNaN(d)
                          ? review.ReviewDate
                          : d.toLocaleDateString();
                      })()}
                    </span>
                  )}
                </div>
              </article>
            ))}
          </div>
            <Link to="/Customer-Services/Reviews" className={`${commonStyles.btn} ${commonStyles.btnPrimary}`}>              
              Read More Reviews
            </Link> 
        </div>
      )}
    </section>
  );
}

export default Reviews;
